import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiConstants from "../../../constants/apiConstants";

const initialState = { content_RowData: {}, screen_Data: [], is_Loading: false, is_Error: null };

export const getScreenData = createAsyncThunk(
    "editContent/fetchData",
    async ({ headers, content_id }, { rejectWithValue }) => {

        try {
            const response = await axios.post(`${apiConstants.GET_API_URL}getScreens`, { org_id: "test" }, { headers });
            const { data } = response.data;

            return { data, content_id };
        } catch (error) {
            const { statusCode, message, redirect_url } = error.response?.data || {};
            if (statusCode === 403) {
                window.open(redirect_url, "_self");
            }
            return rejectWithValue({ message, statusCode });
        }
    }
);

const editContentSlice = createSlice({
    name: "editContent",
    initialState,
    reducers: {
        setEditContentRowData: (state, action) => {
            const rowData = action.payload;
            return { ...state, content_RowData: rowData };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getScreenData.pending, (state) => {
                state.is_Loading = true;
                state.is_Error = null;
            })
            .addCase(getScreenData.fulfilled, (state, action) => {
                const { data, content_id } = action.payload;
                const filtered_data = data.filter(data => data.ic_content_id === content_id);
                const mapped_screens = filtered_data.map(data => ({ id: data.screen_uiid, name: data.ic_screen_name }));

                state.is_Loading = false;
                state.screen_Data = mapped_screens;
            })
            .addCase(getScreenData.rejected, (state, action) => {
                state.is_Loading = false;
                state.is_Error = action.payload?.message || action.error.message;
            });
    },
});

export const { setEditContentRowData } = editContentSlice.actions;

export default editContentSlice.reducer;
